'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/monthsAgo.js
// module id = 370
// module chunks = 1